import {Component} from '@angular/core';

@Component({
    selector: 'tfl-incoming-4-transfer-icon',
    template: require('./incoming-4.html')
})
export class Incoming4TransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/incoming/incoming.4.transfer.icon.ts